import { Iframe } from "./Iframe";
import { Tab } from "./sample/Tab";

export const Messages = () => {
  return (
    <Tab>
      <Iframe url="messages-employee" />
    </Tab>
  );
};
